/* eslint-disable max-lines */
import React, { useState, useRef, useEffect } from 'react'
import {
  Box, ResponsiveBox, ResponsiveText, IcoMoon,
  CloseIcon, useResponsiveWrapperContext,
} from '@usap/uicomponents'
import { OverlaySpinner } from '@usap/widgets'
import useListenOnVehicleSelect from '../hooks/useListenOnVehicleSelect'
import useHandleAddVehicle from '../hooks/useHandleAddVehicle'
import useHandleViewCorrectPart from '../hooks/useHandleViewCorrectPart'
import useStyle from './useStyle'
import { GTM } from '../../../../../../../helpers'
import useWmoEnabled from '../../../../../../../hooks/useWmoEnabled'
import { usePowersports } from '../../../../../../../hooks/usePowersports'
import DoesNotFitWmo from './DoesNotFitWmo'

const DoesNotFit = props => {
  const { data } = props
  const { product, modifiers } = data
  const [showSpinner, shouldShowSpinner] = useState(false)
  const initGtmFitWarning = useRef(false)
  const isWmoEnabled = useWmoEnabled()
  const isPowersportsEnabled = usePowersports()

  let vehicle = ''

  if (modifiers && modifiers.vehicle && modifiers.vehicle.details) {
    const {
      year, make, model, submodel, engine,
    } = modifiers.vehicle.details
    vehicle = [
      `${year}`,
      `${make}`,
      `${model}`,
      `${submodel || ''}`,
      `${engine || ''}`,
    ].join(' ')
  }

  useEffect(
    () => {
      if (!initGtmFitWarning.current) {
        const { fitWarning } = GTM
        fitWarning(
          'Does Not Fit',
          {
            ...modifiers.vehicle.details,
          },
        )
        initGtmFitWarning.current = true
      }
    },
    [modifiers?.vehicle?.details],
  )

  const handleViewCorrectPart = useHandleViewCorrectPart({
    product, modifiers,
  })

  const handleChangeVehicle = useHandleAddVehicle({ product })

  useListenOnVehicleSelect({
    shouldShowSpinner, product,
  })

  const style = useStyle()

  const { isDesktop } = useResponsiveWrapperContext()
  const correctPartCtaTestId = isDesktop ? 'desktop-this-part-does-not-fit-view-correct-part-cart' : 'wom-this-part-does-not-fit-view-correct-part-cart'
  const changeVehicleCtaTestId = isDesktop ? 'desktop-this-part-does-not-fit-change-vehicle-cart' : 'wom-this-part-does-not-fit-change-vehicle-cart'

  const isPowersport = isPowersportsEnabled && ((typeof modifiers.vehicle.details.vehicleType !== 'undefined' &&
                        modifiers?.vehicle?.details?.vehicleType?.toLowerCase() !== 'car/truck/suv') ||
                        typeof modifiers.vehicle.details.vehicleType === 'undefined')

  if (isWmoEnabled) {
    return (
      <DoesNotFitWmo
        product={product}
        vehicle={vehicle}
        handleViewCorrectPart={handleViewCorrectPart}
        correctPartCtaTestId={correctPartCtaTestId}
        changeVehicleCtaTestId={changeVehicleCtaTestId}
        shouldShowSpinner={shouldShowSpinner}
        showSpinner={showSpinner}
        isPowersport={isPowersport}
      />
    )
  }

  return (
    <ResponsiveBox
      border={style.wrapperBorder}
      round="4px"
      pad={style.wrapperPad}
      fxMargin={style.wrapperFxMargin}
    >
      <Box direction="row" style={style.containerPosition}>
        <OverlaySpinner active={showSpinner} />
        <Box align="center" justify="center" style={style.iconWrapperMinWidth}>
          <Box
            justify="center"
            align="center"
            margin="xsmall"
            width="34px"
            height="34px"
            round="50%"
            background="red"
          >
            <IcoMoon icon={CloseIcon} color="white" size="24px" />
          </Box>
        </Box>
        <Box pad={style.textWrapperPad} align="start" justify="center" width="100%">
          <ResponsiveText weight="bold" color="dark-2" fxSize={style.textFxSize}>
            This Part Does Not Fit
          </ResponsiveText>

          {(vehicle !== '') && (
            <ResponsiveText weight="bold" color="dark-2" fxSize={style.linkFxSize}>
              {vehicle}
            </ResponsiveText>
          )}

          <Box direction="row" align="center" justify="between" margin={style.linkMarginTop}>
            <ResponsiveText
              color="blueLink"
              weight="bold"
              fxSize={style.linkFxSize}
              onClick={handleViewCorrectPart}
              style={style.linkViewCursor}
              data-testid={correctPartCtaTestId}
            >
              View Correct Part
            </ResponsiveText>
            <ResponsiveText
              color="blueLink"
              weight="bold"
              fxSize={style.linkFxSize}
              onClick={handleChangeVehicle}
              style={style.linkCursor}
              data-testid={changeVehicleCtaTestId}
            >
              Change Vehicle
            </ResponsiveText>
          </Box>
        </Box>
      </Box>
    </ResponsiveBox>
  )
}

export default DoesNotFit
